import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

<template>
  <span class="block min-w-0 sm:max-w-48" data-test-entity-field {{mergeClasses}} ...attributes>
    <span class="block truncate text-sm text-gray-500" data-test-entity-field-label>{{@label}}</span>
    <span class="block truncate text-sm text-black mt-0.5" data-test-entity-field-value>{{yield}}</span>
  </span>
</template>
